<div class="promotion-code-child-component">
  <h5>Eligibility Setting</h5>
  <div class="promotion-code-child-component-content">
    <form [formGroup]="form">
        <div class="row">
            <div class="col-4 mb-4">
                <span class="kt-font-bold">Unlock Upon Transfer Out</span>
                <!-- Locked while Target Type is Turnover — that target can only be met by bet volume,
                     so transferring out can never unlock the promo (see transferUnlockDisabled). -->
                <div class="toggle-button" [ngClass]="{'disabled-div': transferUnlockDisabled}">
                    <p>Transfer out allowed after meeting target (unlocks promo).</p>
                    <div class="switch">
                        <input type="checkbox" formControlName="transfer_unlock" [checked]="form.value.transfer_unlock == 1" (change)="onChangeToggle($event, 'transfer_unlock')" [attr.disabled]="transferUnlockDisabled ? true : null">
                        <div class="slider round">
                            <span class="on">ON</span>
                            <span class="off">OFF</span>
                        </div>
                    </div>
                </div>
                <span class="reminder-text" *ngIf="isFreeSpin && isTurnoverTarget">Not applicable when Target Type is Turnover — use Auto Unlock.</span>
            </div>
            <div class="col-4 mb-4">
                <span class="kt-font-bold">Auto Unlock</span>
                <div class="toggle-button" [ngClass]="{'disabled-div': !isFreeSpin}">
                    <p>Not applicable when "Unlock Upon Transfer Out" is checked.</p>
                    <div class="switch">
                        <input type="checkbox" formControlName="auto_unlock" [checked]="form.value.auto_unlock == 1" (change)="onChangeToggle($event, 'auto_unlock')" [attr.disabled]="!isFreeSpin ? true : null">
                        <div class="slider round">
                            <span class="on">ON</span>
                            <span class="off">OFF</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-4 mb-4">
                <span class="kt-font-bold">Last Deposit</span>
                <div class="toggle-button">
                    <p>Deposit to main wallet first. No other promotions allowed.</p>
                    <div class="switch">
                        <input type="checkbox" formControlName="last_deposit" [checked]="form.value.last_deposit == 1" (change)="onChangeToggle($event, 'last_deposit')">
                        <div class="slider round">
                            <span class="on">ON</span>
                            <span class="off">OFF</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-4 mb-4">
                <span class="kt-font-bold">Auto Approve</span>
                <div class="toggle-button disabled-div">
                    <p>Auto approves promotion applied or claimed from user portal by the user.</p>
                    <div class="switch">
                        <input type="checkbox" formControlName="auto_approve" [checked]="form.value.auto_approve == 1" (change)="onChangeToggle($event, 'auto_approve')" [attr.disabled]="true">
                        <div class="slider round">
                            <span class="on">ON</span>
                            <span class="off">OFF</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-4 mb-4">
                <span class="kt-font-bold">Max Per Player (Lifetime)</span>
                <input type="number" class="form-control" (wheel)="false" formControlName="max_per_player" (keydown)="onNumberKeydown($event)" (paste)="onPaste($event)" placeholder="0 = unlimited" #focusfield/>
                <span class="reminder-text">Enter 0 for unlimited</span>
            </div>
            <div class="col-4 mb-4">
                <span class="kt-font-bold">Daily Max <span class="text-danger">*</span></span>
                <input type="number" (wheel)="false" min="0" class="form-control" formControlName="daily_max" (keydown)="onNumberKeydown($event)" (paste)="onPaste($event)" #focusfield [attr.disabled]="!isFreeSpin ? true : null"/>
            </div>
        </div>

        <!-- Target Amount — Free Spin only (AIO-71840) -->
        <ng-container *ngIf="isFreeSpin">
            <div class="mb-3">
                <span style="display:inline-flex; align-items:center; font-family:'Poppins'; font-weight:600; font-style:italic; font-size:15px; line-height:100%; letter-spacing:0; color:#2778C4;">
                    <span style="display:inline-block; width:48px; height:2px; background:#2778C4; margin-right:10px;"></span>Target Amount
                </span>
            </div>
            <div class="row">
                <!-- Bypass Turnover first — when ON, the Target Amount inputs below are hidden and a
                     complete default target is saved automatically (immediate unlock on claim). -->
                <div class="col-4 mb-4">
                    <span class="kt-font-bold">Bypass Turnover</span>
                    <!-- Locked without the Bypass Promotion Turnover permission (mirrors v1): the saved
                         state stays visible and keeps flowing into the payload, but can't be changed. -->
                    <div class="toggle-button" [ngClass]="{'disabled-div': !canBypassPromotionTurnover}">
                        <p>Bonus unlocks immediately on claim with no turnover requirement.</p>
                        <div class="switch">
                            <input type="checkbox" [checked]="bypassTurnover" (change)="onBypassTurnoverChange($event)" [attr.disabled]="!canBypassPromotionTurnover ? true : null">
                            <div class="slider round">
                                <span class="on">ON</span>
                                <span class="off">OFF</span>
                            </div>
                        </div>
                    </div>
                    <span class="reminder-text" *ngIf="!canBypassPromotionTurnover">No permission to change Bypass Turnover.</span>
                </div>
                <ng-container *ngIf="!bypassTurnover">
                    <div class="col-4 mb-4">
                        <span class="kt-font-bold">Target Type <span class="text-danger">*</span></span>
                        <select class="form-control" formControlName="target_type" (change)="onTargetTypeChange()">
                            <option [ngValue]="null" [disabled]="true">Please Select</option>
                            <option *ngFor="let t of targetTypes" [ngValue]="t.id">{{ t.name }}</option>
                        </select>
                    </div>
                    <div class="col-4 mb-4">
                        <span class="kt-font-bold">Transfer Amount <span class="text-danger">*</span></span>
                        <select class="form-control" formControlName="type">
                            <option [ngValue]="null" [disabled]="true">Please Select</option>
                            <option [ngValue]="1">Included</option>
                            <option [ngValue]="2">Excluded</option>
                        </select>
                    </div>
                    <div class="col-4 mb-4">
                        <span class="kt-font-bold">Target Multiplier <span class="text-danger">*</span></span>
                        <input type="number" (wheel)="false" min="1" class="form-control" formControlName="target_multiplier" (keydown)="onNumberKeydown($event)" (paste)="onPaste($event)" placeholder="e.g. 3"/>
                    </div>
                    <div class="col-4 mb-4">
                        <span class="kt-font-bold">Game Categories <span class="text-danger">*</span></span>
                        <input type="text" class="form-control" value="Slots" disabled/>
                    </div>
                    <div class="col-4 mb-4">
                        <span class="kt-font-bold">Game Provider <span class="text-danger">*</span></span>
                        <!-- Read-only display of the Free Spin Game Provider (Basic Setting) — same style as Game Categories -->
                        <div style="position: relative;">
                            <input type="text" class="form-control" [value]="freeSpinProviderLabel" disabled/>
                            <i *ngIf="isGameProvidersLoading" class="spinner-border spinner-border-sm" style="position: absolute; right: 15px; top: calc(50% - 0.5rem);"></i>
                        </div>
                    </div>
                </ng-container>
            </div>
            <!-- Target Amount formula (mirrors v1) — hidden when Bypass Turnover unlocks immediately -->
            <p class="mt-1" *ngIf="!bypassTurnover && targetAmountFormula">{{ targetAmountFormula }}</p>
            <p class="mt-1 kt-font-info" *ngIf="bypassTurnover">Bypass Turnover enabled — bonus will unlock immediately upon claim</p>
        </ng-container>
    </form>
  </div>
</div>